import { Fragment } from 'react';
import ReactCropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import cx from 'classnames';
import cn from './Cropper.css.json';
import './Cropper.css';

/**
 * @internal
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Cropper = props => {
  return props.src.length > 0 ? /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("img", {
      src: props.src,
      onError: props.onError,
      className: cn.invisibleImage
    }), /*#__PURE__*/_jsx(ReactCropper, {
      className: cx(cn.cropper, props.ellipse && cn.ellipse, props.className),
      onInitialized: cropper => {
        if (props.cropperRef) {
          props.cropperRef.current = cropper;
        }
      },
      viewMode: 2,
      dragMode: "none",
      toggleDragModeOnDblclick: false,
      preview: props.previewClassName ? `.${props.previewClassName}` : undefined,
      minCropBoxWidth: 1,
      minCropBoxHeight: 1,
      src: props.src,
      aspectRatio: props.aspectRatio ?? 1,
      guides: false,
      ready: props.onReady
    }, props.cropperKey)]
  }) : null;
};
//# sourceMappingURL=Cropper.js.map